import React, {Suspense} from 'react';
import {LayoutProps} from 'components/Layouts/Layout.types';

import Footer from './ArticleLayoutFooter';

export function AudioLayout({children}: LayoutProps): React.ReactElement {
  return (
    <main className="w-full min-w-full min-h-screen bg-pink-100">
      <div className="mx-auto w-full max-w-7xl py-10 h-[100vh]">
        <Suspense>{children}</Suspense>
      </div>
      <Footer />
    </main>
  );
}
